module.exports = __webpack_public_path__ + "static/assets/9693e907bcffe7a9b0b24e6e8ad3bb42.png";